<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-body">
                            <h4>Gestión de Horarios</h4>
                            <p class="text-muted">Administra los horarios disponibles del personal médico.</p>
                            <div class="form-group">
                                <label for="diaSemana">Día de la Semana</label>
                                <select id="diaSemana" v-model="newSchedule.dia_semana" class="form-control" required>
                                    <option value="" disabled>Selecciona un día</option>
                                    <option value="lunes">Lunes</option>
                                    <option value="martes">Martes</option>
                                    <option value="miércoles">Miércoles</option>
                                    <option value="jueves">Jueves</option>
                                    <option value="viernes">Viernes</option>
                                    <option value="sábado">Sábado</option>
                                    <option value="domingo">Domingo</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="horaInicio">Hora Inicio</label>
                                <input type="time" id="horaInicio" v-model="newSchedule.hora_inicio"
                                    class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label for="horaFin">Hora Fin</label>
                                <input type="time" id="horaFin" v-model="newSchedule.hora_fin" class="form-control"
                                    required />
                            </div>
                            <div class="form-group" v-if="editingScheduleId">
                                <label for="estatus">Estatus</label>
                                <select id="estatus" v-model="newSchedule.estatus" class="form-control" required>
                                    <option value="activo">Activo</option>
                                    <option value="inactivo">Inactivo</option>
                                </select>
                            </div>
                            <div v-if="userStats !== 1">
                                <vs-button class="mt-3" @click="validateAndCreateSchedule" color="rgb(59,222,200)" gradient block>
                                    {{ editingScheduleId ? "✏️ Actualizar Horario" : "💾 Guardar Horario" }}
                                </vs-button>
                                <div class="d-flex justify-content-center gap-2">
                                    <a class="smallText text-center"  @click="resetForm"
                                    href="#">Limpiar Formulario</a>
                                </div>
                                <p class="mt-3">Marca la casilla si cuentas con un documento oficial que avale tus horarios de atención (por ejemplo, un aviso a <strong>COFEPRIS</strong> u otra autoridad sanitaria), puedes ingresarlo aquí para dejar constancia dentro de tu perfil profesional. Este dato es opcional y sólo será visible para ti dentro de Medicynia.
                                </p>
                                <div class="form-check">
                                    <input type="checkbox" id="certificado" v-model="estaCertificado" class="form-check-input" />
                                    <label class="form-check-label" for="certificado">
                                        Horario certificado (si coincide con lo declarado ante COFEPRIS)
                                    </label>
                                </div>
                            </div>
                            <div v-else>
                                <div class="alert alert-warning text-center mt-3">
                                        ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                                        <router-link to="/paquetes">Renovar aquí</router-link>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 mt-2 mb-4" v-if="schedules.length > 0">
                    <h4>Lista de Horarios</h4>
                    <div class="table-responsive">
                        <vs-table class="custom-table">
                            <template #thead>
                                <vs-tr>
                                    <vs-th>Día</vs-th>
                                    <vs-th>Hora Inicio</vs-th>
                                    <vs-th>Hora Fin</vs-th>
                                    <vs-th>Estatus</vs-th>
                                    <vs-th>Acciones</vs-th>
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr :key="schedule.id" v-for="schedule in schedules" :data="schedule">
                                    <vs-td>{{ schedule.dia_semana }}</vs-td>
                                    <vs-td>{{ formatTime(schedule.hora_inicio) }}</vs-td>
                                    <vs-td>{{ formatTime(schedule.hora_fin) }}</vs-td>
                                    <vs-td>{{ schedule.estatus === 'activo' ? 'Disponible' : 'No se atiende ese día' }}</vs-td>
                                    <vs-td>
                                        <vs-button size="small" color="rgb(59,222,200)" gradient block small
                                            @click="editSchedule(schedule)">
                                            Seleccionar
                                        </vs-button>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>

        <vs-dialog v-model="showDeleteDialog" title="Confirmar Eliminación" class="custom-dialog">
            <div class="container">
                <div class="row mb-3 mt-3">
                    <div class="col-md-12 text-center">
                        <span class="material-icons md-48 text-danger">warning</span>
                        <h4>Eliminar Horario</h4>
                        <p>¿Estás seguro que deseas eliminar el horario del <strong>{{ scheduleToDelete?.dia_semana
                                }}</strong>?</p>
                        <div class="d-flex justify-content-center gap-3">
                            <vs-button @click="confirmDeleteSchedule" color="rgb(59,222,200)" gradient>
                                Sí, deseo continuar
                            </vs-button>
                            <vs-button @click="showDeleteDialog = false" color="rgb(255,77,77)" gradient>
                                Cancelar
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Horarios",
        props: {
            personal_medico_id: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                estaCertificado: false, // Track if the user has a certificate
                certificacionId: null, // Stores the ID of the 'horario_cofepris' certification
                schedules: [],
                newSchedule: {
                    dia_semana: "",
                    hora_inicio: "",
                    hora_fin: "",
                    estatus: "activo", // Default value
                },
                editingScheduleId: null, // Track the schedule being edited
                showDeleteDialog: false, // Controls the visibility of the delete confirmation dialog
                scheduleToDelete: null, // Stores the schedule to be deleted
                userStats: null, // User status
            };
        },
        mounted() {
            setTimeout(() => {
                this.fetchSchedules();
                this.fetchCertificacionHorario();
            }, 333);
            setTimeout(() => {
                this.userStats = this.getUserStatus();
            }, 500);
        },
        watch: {
            estaCertificado(newValue) {
                if (newValue === true && !this.certificacionId) {
                    // User checked the box, and no certification exists yet
                    this.createCertificacionHorario();
                } else if (newValue === false && this.certificacionId) {
                    // User unchecked the box, and a certification exists
                    this.deleteCertificacionHorario();
                }
            }
        },
        methods: {
            async fetchCertificacionHorario() {
                if (!this.personal_medico_id) {
                    console.warn("El personal_medico_id aún no está disponible para fetchCertificacionHorario.");
                    return;
                }
                try {
                    const response = await axios.get(`${API}/obtener_certificacion`, {
                        params: {
                            personal_medico_id: this.personal_medico_id,
                            tipo_certificacion: "horario_cofepris",
                        },
                    });
                    if (response.data.status === "success" && response.data.data) {
                        this.certificacionId = response.data.data.id;
                        this.estaCertificado = true;
                    } else {
                        // This case might not be hit if 404 is thrown as an error
                        this.certificacionId = null;
                        this.estaCertificado = false;
                    }
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        this.certificacionId = null;
                        this.estaCertificado = false;
                    } else {
                        console.error("Error al obtener la certificación de horario:", error);
                        this.notify("error", "Error al verificar la certificación del horario.");
                        // Ensure consistent state on other errors
                        this.certificacionId = null;
                        this.estaCertificado = false;
                    }
                }
            },
            async createCertificacionHorario() {
                if (!this.personal_medico_id) {
                    this.notify("error", "No se pudo identificar al personal médico.");
                    this.estaCertificado = false; // Revert
                    return;
                }
                try {
                    const payload = {
                        personal_medico_id: this.personal_medico_id,
                        tipo_certificacion: "horario_cofepris",
                        descripcion: "Su horario coincide con su documento legal",
                    };
                    const response = await axios.post(`${API}/crear_certificacion`, payload);
                    if (response.data.status === "success") {
                        this.notify("success", "Certificación de horario guardada exitosamente.");
                        await this.callAudit(this.personal_medico_id, "CREAR", "personal_medico_certificaciones", this.personal_medico_id, "Su horario coincide con su documento legal");
                        
                        // Fetch again to get the ID and confirm state
                        await this.fetchCertificacionHorario();
                    } else {
                        this.notify("error", response.data.message || "Error al guardar la certificación del horario.");
                        this.estaCertificado = false; // Revert if creation failed
                    }
                } catch (error) {
                    console.error("Error al crear la certificación de horario:", error);
                    this.notify("error", "Error al guardar la certificación del horario.");
                    this.estaCertificado = false; // Revert on exception
                }
            },
            async deleteCertificacionHorario() {
                if (!this.certificacionId) {
                    this.notify("error", "No se encontró ID de certificación para eliminar.");
                    // estaCertificado is already false, so no UI reversion needed here
                    return;
                }
                try {
                    const response = await axios.delete(`${API}/eliminar_certificacion/${this.certificacionId}`);
                    if (response.data.status === "success") {
                        this.notify("success", "Certificación de horario eliminada exitosamente.");
                        await this.callAudit(this.personal_medico_id, "BORRAR", "personal_medico_certificaciones", this.certificacionId, "Su horario no coincide con su documento legal");
                        this.certificacionId = null;
                        // estaCertificado is already false due to user action triggering the watcher
                    } else {
                        this.notify("error", response.data.message || "Error al eliminar la certificación del horario.");
                        this.estaCertificado = true; // Revert if deletion failed
                    }
                } catch (error) {
                    console.error("Error al eliminar la certificación de horario:", error);
                    this.notify("error", "Error al eliminar la certificación del horario.");
                    this.estaCertificado = true; // Revert on exception
                }
            },
            async fetchSchedules() {
                if (!this.personal_medico_id) {
                    console.warn("El personal_medico_id aún no está disponible.");
                    return;
                }
                try {
                    const response = await axios.get(`${API}/listar_horarios`, {
                        params: { personal_medico_id: this.personal_medico_id },
                    });
                    if (response.data.status === "success") {
                        this.schedules = response.data.data;
                    } else {
                        this.notify("error", response.data.message);
                    }
                } catch (error) {
                    console.error("Error al listar horarios:", error);
                    this.notify("error", "Error al listar los horarios.");
                }
            },
            editSchedule(schedule) {
                this.editingScheduleId = schedule.id;
                this.newSchedule = { ...schedule };
            },
            validateAndCreateSchedule() {
                if (
                    !this.vEmpty(this.newSchedule.dia_semana, "Día de la Semana") ||
                    !this.vEmpty(this.newSchedule.hora_inicio, "Hora Inicio") ||
                    !this.vEmpty(this.newSchedule.hora_fin, "Hora Fin")
                ) {
                    return;
                }

                if (this.isDuplicateDay(this.newSchedule.dia_semana)) {
                    this.notify("error", "Ya existe un horario registrado para este día.");
                    return;
                }

                if (this.newSchedule.hora_inicio >= this.newSchedule.hora_fin) {
                    this.notify("error", "La hora de inicio no puede ser mayor o igual a la hora de fin.");
                    return;
                }

                this.createSchedule();
            },
            isDuplicateDay(dia_semana) {
                return this.schedules.some(
                    (schedule) =>
                        schedule.dia_semana === dia_semana &&
                        schedule.id !== this.editingScheduleId
                );
            },
            async createSchedule() {
                if (!this.newSchedule.dia_semana || !this.newSchedule.hora_inicio || !this.newSchedule.hora_fin) {
                    this.notify("error", "Por favor completa todos los campos requeridos.");
                    return;
                }

                try {
                    const payload = {
                        personal_medico_id: this.personal_medico_id,
                        ...this.newSchedule,
                    };

                    let response;
                    if (this.editingScheduleId) {
                        response = await axios.put(`${API}/actualizar_horario/${this.editingScheduleId}`, payload);
                    } else {
                        response = await axios.post(`${API}/crear_horario`, payload);
                    }

                    if (response.data.status === "success") {
                        this.notify("success", this.editingScheduleId ? "Horario actualizado exitosamente." : "Horario creado exitosamente.");
                        this.resetForm();
                        this.fetchSchedules();
                    } else {
                        this.notify("error", response.data.message);
                    }
                } catch (error) {
                    console.error("Error al guardar horario:", error);
                    this.notify("error", "Error al guardar el horario.");
                }
            },
            resetForm() {
                this.newSchedule = {
                    dia_semana: "",
                    hora_inicio: "",
                    hora_fin: "",
                    estatus: "activo", // Default value
                };
                this.editingScheduleId = null;
            },
            deleteSchedule(scheduleId) {
                this.scheduleToDelete = this.schedules.find(schedule => schedule.id === scheduleId);
                this.showDeleteDialog = true;
            },
            async confirmDeleteSchedule() {
                if (!this.scheduleToDelete) return;

                try {
                    const response = await axios.delete(`${API}/eliminar_horario/${this.scheduleToDelete.id}`);
                    if (response.data.status === "success") {
                        this.notify("success", "Horario eliminado exitosamente.");
                        this.fetchSchedules();
                    } else {
                        this.notify("error", response.data.message);
                    }
                } catch (error) {
                    console.error("Error al eliminar horario:", error);
                    this.notify("error", "Error al eliminar el horario.");
                } finally {
                    this.showDeleteDialog = false;
                    this.scheduleToDelete = null;
                }
            },
            formatTime(time) {
                if (!time) return '';
                const [hour, minute] = time.split(':');
                const hourInt = parseInt(hour, 10);
                const period = hourInt >= 12 ? 'PM' : 'AM';
                const formattedHour = hourInt % 12 || 12; // Convert 0 to 12 for 12-hour format
                return `${formattedHour}:${minute} ${period}`;
            },
        },
    };
</script>

<style scoped>
    .list-group-item {
        margin-bottom: 10px;
    }
</style>